{
  "enum": {
    "ExcFixV1MessageType": {
      "BUSINESS_MESSAGE_REJECT": "Business Message Reject",
      "EXECUTION_REPORT": "Execution Report",
      "NEW_ORDER_SINGLE": "New Order Single",
      "ORDER_CANCEL_REJECT": "Order Cancel Reject",
      "ORDER_CANCEL_REPLACE_REQUEST": "Order Cancel Replace Request",
      "ORDER_CANCEL_REQUEST": "Order Cancel Request",
      "ORDER_STATUS_REQUEST": "Order Status Request",
      "UNKNOWN": "Unknown",
      "UNSPECIFIED": "Unspecified"
    }
  }
}